import React from 'react'
import './header.css'

export default function Header() {
  return (
    <div className="Header">
      <h1>Demo - noise suppression</h1>
      <p>
        Web apps for checking `noiseSuppression` effectiveness for WebRTC communication.
      </p>
    </div>
  )
}